import { render, staticRenderFns } from "./RsaPianificazioneEditAccessi.vue?vue&type=template&id=62f55f23"
import script from "./RsaPianificazioneEditAccessi.vue?vue&type=script&lang=js"
export * from "./RsaPianificazioneEditAccessi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports